import { actionsType } from '@/modules/FileDetail/components/statusTransition/statusTransitionAction/StatusTransitionAction.type';

export const statusTransitionDetailCardActionsGenerator = (
  description: string | null,
): actionsType => {
  if (description) {
    return 'showDescription';
  }
  return '';
};
